import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import type { VariantProps } from "class-variance-authority"
import { buttonVariants } from './buttonVariants'

import { cn } from "@/shared/utils/cn"

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    const typeProp = !asChild
      ? { type: (props as React.ButtonHTMLAttributes<HTMLButtonElement>).type ?? "button" }
      : {}
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...typeProp}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button }
